import { keysToSnake } from '#/api/adapters/wireCase';

export const coPath = (id, sub = '') => `/crm/customer-order/${id}${sub}`;

/** 帶 `Idempotency-Key`；同一次操作重送沿用同一把（≤128 字、不可 `system:` 開頭）。 */
export function withIdempotencyKey(idempotencyKey) {
  if (!idempotencyKey) {
    throw new Error('Idempotency-Key is required');
  }
  return { headers: { 'Idempotency-Key': idempotencyKey } };
}

export function newIdempotencyKey() {
  return globalThis.crypto?.randomUUID?.() ?? `coc-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export const toWire = (payload) => keysToSnake(payload);
